module.exports = __webpack_public_path__ + "img/encuesta_clima_2024.ed8aaec9.webp";